export const offers= [
    {
        img:"https://cms-contents.pharmeasy.in/offer/99a287decc6-FLAT_30OFF.jpg",
        desc:"Flat 30% off + FREE plus membership on purchase of Diabetic, Cardiac & Gastro medicines & health products.",
        code:"GRAND30"
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/81308cc59b5-FLAT_20.jpg",
        desc:"Flat 20% OFF + up to Rs.1000 surprise cashback on your first medicine order. Hurry! Order now, offer valid only on cart value above Rs.999",
        code:"MEGA20"
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/2846076d5d2-Diagnostics-10-min.png",
        desc:"Order medicines and get FLAT 400 OFF on Comprehensive Full Body checkup with Vitamin D and B12.",
        code:"CARE4U"
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/16080f30d6a-1.jpg",
        desc:"Get flat 23% off on Medicine +  Get 3 live Byju’s online classes at Rs 299.",
        code:"PBYJUS23"
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/bb20b7c6548-2.jpg",
        desc:"Get flat 23% off on medicine +  Get 15% upto Rs.200 Instant Discount + Flat Rs.300 AbhiBus Cashback",
        code:"PABUS23"
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/dceebedd00f-Diagnostics-09-min.png",
        desc:"Get FLAT Rs.600 cashback on PharmEasy Labtests booked above Rs.1499.",
        code:"CSH600"
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/b964e016470-Diagnostics-09-min.png",
        desc:"Get FLAT Rs.400 OFF on orders above Rs 1399.",
        code:"WELCOME400"
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/dceebedd00f-Diagnostics-09-min.png",
        desc:"Get FLAT Rs.400 cashback on PharmEasy Labtests booked above Rs.949",
        code:"LAB400"
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/a39f3a0b277-Diagnostics-01-min.png",
        desc:"Get FLAT Rs.200 cashback on PharmEasy Labtests booked above Rs.699.",
        code:"CSHB200"
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/beff77d2d65-Diagnostics-11-min.png",
        desc:"Get FLAT Rs.1000 OFF on booking 2 Comprehensive Full Body checkup with Vitamin D and B12 Packages.",
        code:"GRAND1000"
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/beff77d2d65-Diagnostics-11-min.png",
        desc:"Get FLAT Rs.600 OFF on booking 2 Advance Health Packages.",
        code:"HEALTH600"
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/beff77d2d65-Diagnostics-11-min.png",
        desc:"Get FLAT Rs.1200 OFF on booking 2 Master Checkup with Cancer & Arthritis Packages.",
        code:"GRAND1200"
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/beff77d2d65-Diagnostics-11-min.png",
        desc:"Get FLAT Rs.2000 OFF on booking 4 Comprehensive Full Body checkup with Vitamin D and B12 Packages.",
        code:"WECARE2000"
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/f99f81a36bd-1X1_Log_PE.png?dim=60x0&dpr=2&q=100",
        desc:"Get a health checkup and FREE doctor consultation. Use code FREECONSULT.",
        code:"FREECONSULT"
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/abfb3b37d6a-ease.jpg?dim=60x0&dpr=2&q=100",
        desc:"Get flat 25% discount to new users(Minimum Order Value-899) + Easy my trip discount upto Rs.1000",
        code:"EASE25"
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/e11270f3e3f-paytmcashbackoptimized.png?dim=60x0&dpr=2&q=100",
        desc:"Valid once per user on transactions above ₹600.",
        code:""
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/79c9e323814-AMAZON.jpg?dim=60x0&dpr=2&q=100",
        desc:"Offer valid on transactions above ₹100.",
        code:""
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/6e091f6c840-Father_day_Logo.jpg?dim=60x0&dpr=2&q=100",
        desc:"Offer valid on transactions above ₹500",
        code:""
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/4573f3d084c-25.jpg?dim=60x0&dpr=2&q=100",
        desc:"Get Flat 25% off + up to Rs.5000 surprise cashback on your 1st medicine order. Minimum order value is Rs.999",
        code:""
    },
    {
        img:"https://cms-contents.pharmeasy.in/offer/81308cc59b5-FLAT_20.jpg?dim=60x0&dpr=2&q=100",
        desc:"Flat 20% off + Additional 20% cashback upto Rs.300 on your 1st medicine order",
        code:""
    }
]